module.exports = new __parcel__URL__("ludoPlus.edd7b2af.png").toString();